// 接口地址
//http://120.77.10.20:8800/
//http://zlxxedu.com/
const apiUrl = "http://api.zlxxedu.com/api";
 
export default {
    apiUrl
}